/** @format */

import React, { FunctionComponent, ReactElement, useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import CustomTextButtom from '../../components/Buttons/CustomTextButton';
import I18n from '../../components/Translate/I18n';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import CustomInputExt from '../../components/CustomInput/CustomInputExt';
import { ItemLoaders } from '../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import { SimCardServiceTemplate } from '../../interfaces/platform/SimCardServiceTemplate';
import { usePlatformResellerHeaders, usePlatformResellerList } from '../../modules/lib/hooks/usePlatformResellerHooks';
import { SimpleSelect } from '../../components/Adescom/SimpleSelect';
import Button from '@material-ui/core/Button';
import { ReactComponent as Cancel } from '../../assets/themes/OPL/img/icons/Cancel.svg';

type VirtualComponentAddNewType = {
    open: boolean;
    closeCallback(): void;
    reloadCallback(): void;
};

export const VirtualComponentAddNew: FunctionComponent<VirtualComponentAddNewType> = ({ open, closeCallback, reloadCallback }): ReactElement => {
    const dispatch = useDispatch();
    const platformResellers = usePlatformResellerList([
        { name: 'deleted', value: 0 },
        { name: 'active', value: 1 },
    ]);
    const platformResellerHeader = usePlatformResellerHeaders(platformResellers);
    const [platformResellerId, setPlatformResellerId] = useState<number | null>(null);

    const [templateName, setTemplateName] = useState('');
    const [clipPrefix, setClipPrefix] = useState<string | null>(null);
    const createTemplate = (): void => {
        const newTemplate = {
            templateName: templateName,
            templateItems: '{}',
            active: false,
            defaultFlag: false,
            platformResellerId: platformResellerId,
            clip: true,
            clipPrefix: clipPrefix,
            ussdSmsCommunicationId: -1,
        } as SimCardServiceTemplate;
        const itemLoader = new ItemLoaders(dispatch);
        itemLoader.postWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/sim_card_service_templates')),
            'sim_card_services_templates_post',
            newTemplate,
            (data: SimCardServiceTemplate): void => {
                reloadCallback();
                closeCallback();
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const onChangeEvent = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const value = event.target.value;
        const field = event.target.name;
        switch (field) {
            case 'clipPrefix':
                setClipPrefix(value);
                break;
            default:
                setTemplateName(value);
        }
    };

    const setPlatformResellerCallback = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        setPlatformResellerId(parseInt(event.target.value));
    };

    return (
        <Dialog open={open} maxWidth="xs" fullWidth={true}>
            <DialogTitle id="alert-dialog-title">
                <GridContainer justifyContent={'space-between'}>
                    <GridItem xs={11}>
                        <h4>
                            <I18n trans="prov:features.add_new_template" />
                        </h4>
                    </GridItem>
                    <GridItem xs={1}>
                        <Button onClick={closeCallback} color="primary">
                            <Cancel width={24} height={24} />
                        </Button>
                    </GridItem>
                </GridContainer>
            </DialogTitle>
            <DialogContent>
                <GridContainer>
                    <GridItem xs={12}>
                        <SimpleSelect
                            label="prov:features.platform_reseller"
                            required={true}
                            elements={platformResellerHeader ?? []}
                            fieldName="platformResellerId"
                            dispatchName={'none'}
                            selectedValue={platformResellerId ?? undefined}
                            callback={setPlatformResellerCallback}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomInputExt
                            formControlProps={{ fullWidth: true }}
                            required={true}
                            labelText="prov:features.template_name"
                            name="templateName"
                            value={templateName}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                    <GridItem xs={12}>
                        <CustomInputExt
                            formControlProps={{ fullWidth: true }}
                            required={true}
                            labelText="prov:profile.prefix"
                            name="clipPrefix"
                            value={clipPrefix}
                            onChange={onChangeEvent}
                        />
                    </GridItem>
                </GridContainer>
                <br />
            </DialogContent>
            <DialogActions>
                <CustomTextButtom callback={createTemplate} callbackParam={{}} label="general:common.save" size="sm" />
            </DialogActions>
        </Dialog>
    );
};
